
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useStateMachine } from "little-state-machine";
import { updateAction } from "../actions";
import Steps from "../../Components/Steps";
import FormNavigation from "../FormNavigation";
import DateSelector from "../../Components/DateSelector";
import TextArea from "../../Components/TextArea";
import { DATE_OF_CHANGE, DESCRIPTION } from "../../Constants";
import ErrorMessage from "../../Components/ErrorMessage/index"
import { motion } from "framer-motion";
import { AnimatePresence } from "framer-motion";
import { useEffect } from "react";

const Step3b = () => {
  const { control, register, handleSubmit, formState: { errors } } = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: true,
  });
  const navigate = useNavigate()
  const { actions, state } = useStateMachine({ updateAction });

  const onSubmit = (data: any) => {
    actions.updateAction(data);
    navigate("/step4b");
  };
  const onBack = () => {
    navigate("/step2b");
  };
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <motion.div
      data-testid="step3b"
      key="step3b"
      initial="initial"
      animate="in"
      exit="out"
      variants={{
        initial: {
          opacity: 0,
        },
        in: {
          opacity: 1,
        },
        out: {
          opacity: 0,
        },
      }}
    >
      <Steps step={3} max={4} />
      <AnimatePresence>
        {!!Object.keys(errors)?.length && (<ErrorMessage isMultiple={Object.keys(errors)?.length > 1} />)}
      </AnimatePresence>
      <form onSubmit={handleSubmit(onSubmit)}>
        <section>
          <h2>Change details</h2>
          <DateSelector
            id={DATE_OF_CHANGE}
            name={DATE_OF_CHANGE}
            label="Date of change "
            required={true}
            control={control}
            defaultValue={state?.data[DATE_OF_CHANGE]}
            errorMessage={errors[DATE_OF_CHANGE]?.message as string}
          />
          <TextArea
            errorMessage={errors[DESCRIPTION]?.message as string}
            name={DESCRIPTION}
            id={DESCRIPTION}
            label="Please describe the change "
            register={register}
            defaultValue={state?.data[DESCRIPTION]}
            registerOptions={{
              required: "Please leave a description"
            }}
          />
        </section>
        {!!Object.keys(errors)?.length && (<ErrorMessage isMultiple={Object.keys(errors)?.length > 1} isBottom={true} />)}
        <FormNavigation isLast={false} handleBack={onBack} />
      </form >
    </motion.div>
  );
};

export default Step3b;
